import AES_RSA from './ASE_RSA'
import { AxiosResponse } from 'axios'

const handleDecryptData = (response: AxiosResponse) => {
  // @ts-ignore todo: 回头处理
  if (response?.config?.options?.signature !== 'decrypted') return response
  const { data } = response
  if (data?.data && typeof data.data === 'string') {
    try {
      //console.log('before decrypted rul', response.config.url, data.data)
      const decryptedData = JSON.parse(AES_RSA.decryptedAES(data.data))
      //console.log('after decrypted', decryptedData)
      response.data.data = decryptedData
    } catch (e) {
      console.error('handleDecryptData error', e)
    }
  }
  return response
}

export default handleDecryptData
